export function valnetAccess_isOfRole(vnApp, role: Number) {
    let show = false;

    let roles: Array<any> = vnApp.loggedUser.user.valnet_user.roles;
    let roleIds = [];

    for (let role of roles) {
        roleIds.push(role.id);
    }
    if (roleIds.indexOf(role) > -1) {
        show = true;
    }

    return show;
}


// WEBPACK FOOTER //
// ./vendor/valnet/valnet_access/src/js/helper.ts